<template>
  <div class="stars">
    <div class="stars__active" :style="`width:${score}%`">
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
    </div>
    <div class="stars__inactive">
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
      <fa-icon icon="star"></fa-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stars",
  props: {
    score: {required: true}
  }
}
</script>
